




















import { Component, Vue } from "vue-property-decorator";
import { RestaurantsApi } from "@/services/api-service";
import RestaurantModule from "@/store/restaurant";
import RestaurantInfo from "@/components/RestaurantInfo.vue";
import CHeader from "@/components/CHeader.vue";
import CFooter from "@/components/CFooter.vue";
import RestaurantMenuList from "@/components/RestaurantMenuList.vue";
import CTooltip from "@/components/CTooltip.vue";
import MapViewer from "@/components/MapViewer.vue";
import OrderModule from "@/store/order";

@Component({
  components: {
    RestaurantInfo,
    CFooter,
    CHeader,
    RestaurantMenuList,
    MapViewer,
    CTooltip,
  },
})
export default class RestaurantDetail extends Vue {
  private async mounted() {
    const { uuid } = this.$route.params;
    await this.getRestaurant(uuid);
    const { restaurant } = RestaurantModule;
    // TODO: fix restaurant type
    if (!restaurant?.uuid) {
      return;
    }
    await this.getMenu(restaurant.uuid);
    OrderModule.commitIsAddedCart(false);
  }

  private get isAddedCart() {
    return OrderModule.isAddedCart ? OrderModule.isAddedCart : false;
  }

  private async getRestaurant(uuid: string) {
    // eslint-disable-next-line prettier/prettier
    const restaurantRes = await RestaurantsApi.instance.gerRestaurantByUuid(uuid);
    const restaurant = restaurantRes.data?.data?.restaurant;
    if (!restaurant) {
      return;
    }
    RestaurantModule.commitRestaurant(restaurant);
  }

  private async getMenu(uuid: string) {
    // eslint-disable-next-line prettier/prettier
    const menusRes = await RestaurantsApi.instance.getMenusByRestaurantUuid(uuid);
    const menus = menusRes.data?.data?.items;
    if (!menus) {
      return;
    }
    RestaurantModule.commitMenus(menus);
  }
}
